import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // urlName:'',
  },
  mutations: {
    // Url_Name(state, payload) {
    //   state.urlName = payload;
    //   // console.log('Url_Name',state)
    //   // console.log('Url_Name',payload)
    // },
  },
  actions: {
    // setUrlName({ commit }, state) {
    //   // console.log('setUrlName',state)
    //   commit('Url_Name', state);
    // },
  },
  modules: {
  }
})
